import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { accountCommandsFromContext } from '../account/account-path';
import { AuthStore } from '../stores/auth.store';
import { LOGIN_ROUTE } from './auth-route.constants';

/**
 * `/account` bookmarks and legacy links: send the user into the shell that fits
 * their current URL (or their role/tenant when there is no shell).
 * Bare `/account` is kept only when no admin/tenant shell applies.
 */
export const accountRedirectGuard: CanActivateFn = () => {
  const auth = inject(AuthStore);
  const router = inject(Router);

  return auth.waitUntilSessionReady().pipe(
    map(() => {
      const user = auth.user();
      if (!auth.isAuthenticated() || !user) {
        return router.createUrlTree([LOGIN_ROUTE]);
      }

      const commands = accountCommandsFromContext(router.url, user);
      if (commands.length === 1 && commands[0] === '/account') {
        return true;
      }
      return router.createUrlTree(commands);
    }),
  );
};
